import { logger } from "@/utils/monitoring/logging"

import { getClaimDetailsByMarker, softDeleteClaimDetail } from "../tables/claimDetails/claimDetails"
import { findClaimMarkerById, getClaimMarkersByPhoto, softDeleteClaimMarker } from "../tables/claimMarkers/claimMarkers"
import { softDeletePhoto } from "../tables/photos/photos"
import { deleteClaimPhotoCopies } from "./deleteClaimPhotoCopies"

/**
 * Soft-delete a claim marker together with its details. When the marker was the last one
 * on its claim photo, the now-orphaned photo is soft-deleted too, along with any view
 * photo copied from it.
 */
export async function deleteClaimMarker(markerId: string): Promise<void> {
  const marker = await findClaimMarkerById(markerId)

  await softDeleteClaimMarker(markerId)

  const details = await getClaimDetailsByMarker(markerId)
  for (const detail of details) {
    await softDeleteClaimDetail(detail.id)
  }

  // Drop the claim photo once its last marker is gone
  if (marker) {
    const remainingMarkers = await getClaimMarkersByPhoto(marker.photoId)
    if (remainingMarkers.length === 0) {
      logger.info(`[claim] Deleting orphaned claim photo ${marker.photoId} — last marker removed`)
      await softDeletePhoto(marker.photoId)
      await deleteClaimPhotoCopies({ sourcePhotoId: marker.photoId, sessionId: marker.sessionId })
    }
  }
}
